<template>
    <SectionBlock>
        <DefaultAlgorithmSettingField v-if="!store.crossType" />
        <AlgorithmField />
        <ScoringMatrixField v-if="store.algorithmOption && store.algorithmOption.children.matrix" />
        <WordSizeField v-if="store.algorithmOption && store.algorithmOption.children.word_size" />
        <MatchScoresField v-if="store.algorithmOption && store.algorithmOption.children.match_scores" />
        <GapCostsField />
    </SectionBlock>
</template>

<script>
import * as Widgets from '../widgets/index';
import * as Components from '../components/index';

export default {
    components: {
        ...Components,
        ...Widgets,
    },
    inject: ['store'],
};
</script>
